moduleSpacer = angular.module('spacer.initializer', [])

moduleSpacer.service 'Spacer', ["$timeout", "$injector", "ns", ($timeout, $injector, ns) ->
  'use strict'
  Y = undefined

  spacer =
    init: (y) ->
      Y = y
      @initResize()
    resizers: []
    findSpacers: ->
      layoutEditor = $injector.get "layoutEditor"
      @spacers = layoutEditor.layout.all ".#{ns.spacerClass}"
    initResize: ->
      self = @
      @findSpacers()
      @spacers.each (spacer) ->
        if !spacer.one(".#{ns.spacerContentClass}")
          spacer.one(ns.widgetWrapperClass).append "<div class='#{ns.spacerContentClass}'></div>"
        resizer =  new Y.Resize
          node: spacer
          handles: "b"
          proxy: true
        self.setEvents resizer
        self.resizers.push resizer
    setEvents: (spacer) ->
      spacer.on "resize:start", @_resizeStart, @
      spacer.on "resize:resize", @_updateAspectRatio, @
      spacer.after "resize:end", @_resizeEnd, @
    addRuler: ->
      if !@target.one(".str-ruler")
        height = @target.getStyle "height"
        @target.one(ns.widgetWrapperClass).append "<div class='str-ruler'>#{height}</div>"
    removeRuler: ->
      @target.one(".str-ruler").remove()
    _resizeStart: (event) ->
      @target = event.target.get "node"
      @addRuler()
    _resizeEnd: (event) ->
      layoutEditor = $injector.get "layoutEditor"
      @target.setStyles width: null
      layoutEditor.save()
      Y.all(".#{ns.spacerWrapperClass}").remove()
      @removeRuler()
      @initResize()
    _updateAspectRatio: (event) ->
      info = event.info
      spacerContent = @target.one(".#{ns.spacerContentClass}")
      height = @target.getStyle "height"
      @target.one(".str-ruler").setHTML height
      @_setPadding spacerContent, height
      @target.widget.padding = parseInt height
    _setPadding: (el, padding) ->
      if el
        el.setStyle "paddingBottom", parseInt(padding) + "px"
    destroy: ->
      _.each @resizers, (resizer) ->
        resizer.destroy()
        Y.all(".#{ns.spacerWrapperClass}").remove()
      return
  spacer

]



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/spacer/spacer.initializer.coffee